import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardBody,
  Center,
  Heading,
  HStack,
  SimpleGrid,
  Spinner,
  Text,
  useToast,
} from "@chakra-ui/react";
import { ClientTechnicianModel } from "../services";
import { AddTechnicianForm } from "../components";

export default function Technicians() {
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const fetchTechs = async () => {
    try {
      let response = await ClientTechnicianModel.get();
      setTechnicians(response.data.data);
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTechs();
  }, []);

  return (
    <>
      <HStack
        justifyContent="space-between"
        alignItems={{ base: "start", md: "center" }}
        flexDirection={{ base: "column", md: "row" }}
        mb={4}
      >
        <Heading fontSize={{ base: "xl", md: "3xl" }}>Technicians</Heading>
        <AddTechnicianForm fetchTechs={fetchTechs} />
      </HStack>
      {loading ? (
        <Center>
          <Spinner />
        </Center>
      ) : technicians.length ? (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={3}>
          {technicians.map((item, i) => {
            return (
              <Card key={i}>
                <CardBody p={3} display="flex" gap={2} alignItems="center">
                  <Avatar
                    src={
                      item.technicianId?.firstName +
                      " " +
                      item.technicianId?.lastName
                    }
                    name={
                      item.technicianId?.firstName +
                      " " +
                      item.technicianId?.lastName
                    }
                    size="md"
                  />
                  <Box overflow="hidden">
                    <Heading as="h4" fontSize="base">
                      {item.technicianId?.firstName +
                        " " +
                        item.technicianId?.lastName}
                    </Heading>
                    <Text>{item.technicianId?.email}</Text>
                  </Box>
                </CardBody>
              </Card>
            );
          })}
        </SimpleGrid>
      ) : (
        <Text textAlign="center" color="gray">
          No Technicians Found
        </Text>
      )}
    </>
  );
}
